export default "__VITE_ASSET__a0QN_vmw__"